export default __webpack_public_path__ + "static/media/ic-loading.8ee6321f.svg";